export type Service = {
  id: string
  title: string
  description: string
  image: string
}

export const services: Service[] = [
  {
    id: 'interior-painting',
    title: 'Interior Painting',
    description:
      'Transform your interior with clean lines, professional preparation, and a beautiful finish.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0ddef1fd-07a2-41e9-895a-c59ec548d999.jpg',
  },
  {
    id: 'exterior-painting',
    title: 'Exterior Painting',
    description:
      'Give your home a fresh, durable exterior finish that improves curb appeal.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c379f6ec-bf7d-49b0-b665-cddcde60402c.jpg',
  },
  {
    id: 'kitchen-remodeling',
    title: 'Kitchen Remodeling',
    description:
      'Upgrade your kitchen into a space that looks better, functions better, and feels like home.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/edb58944-fe2c-4049-85bc-c6441520b373.jpg',
  },
  {
    id: 'bathroom-remodeling',
    title: 'Bathroom Remodeling',
    description:
      'Create a modern, comfortable bathroom with quality materials and craftsmanship.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8323d5fe-ac33-4d6e-a21c-e035eafda482.jpg',
  },
  {
    id: 'home-remodeling',
    title: 'Home Remodeling',
    description:
      'From individual rooms to larger renovations, bring your vision to life.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/dd980e81-24e7-40e0-8d5f-77d56cf87a0e.jpg',
  },
  {
    id: 'trim-finish',
    title: 'Trim & Finish Work',
    description:
      'Professional attention to the details that make a renovation feel complete.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8d4613b3-01cb-42ce-bd01-3e4739f3f75e.jpg',
  },
]
